export const DOCUMENT_TYPES_BRAZIL = [
  {
    value: 'PAS',
    text: 'PAS'
  },
  {
    value: 'CPF',
    text: 'CPF'
  },
  {
    value: 'DNI',
    text: 'DNI'
  }
];
